import { JsonPatchOperation } from "_shared/_api/attorney-hub-api-service";
import EntityAgreement from "legal-entities/agreements/entity-agreement";

export default class UpdateEntityAgreementAPIRequest {
  public get payload(): JsonPatchOperation[] {
    return [...this._payload];
  }

  constructor(oldAgreement: EntityAgreement, newAgreement: EntityAgreement) {
    if (
      (newAgreement.termsFileId && !oldAgreement.termsFileId) ||
      !oldAgreement.termsFileId?.isEqualTo(newAgreement.termsFileId)
    ) {
      this._payload.push({
        op: "replace",
        path: "/TermsFileId",
        value: newAgreement.termsFileId?.value ?? null,
      });
    }

    if (newAgreement.entityName.value !== oldAgreement.entityName.value) {
      this._payload.push({
        op: "replace",
        path: "/EntityName",
        value: newAgreement.entityName.value,
      });
    }

    if (
      (!newAgreement.entityLocation && oldAgreement.entityLocation) ||
      !newAgreement.entityLocation?.isEqualTo(oldAgreement.entityLocation)
    ) {
      this._payload.push({
        op: "replace",
        path: "/EntityLocation",
        value: newAgreement.entityLocation?.toJSON() ?? null,
      });
    }
  }
  private readonly _payload: JsonPatchOperation[] = [];
}
